export default __webpack_public_path__ + "static/media/angellist-brands.2e628feb.svg";